/* @flow weak */

'use strict';

const Reflux = require('reflux');
const request = require('superagent');
const _ = require('lodash');

const UCActions = require('../actions/UCActions.jsx');

const ProductStore = require('../stores/ProductStore.jsx');
const QuestionStore = require('../stores/QuestionStore.jsx');
const PartStore = require('../stores/PartStore.jsx');
const AnswerStore = require('../stores/AnswerStore.jsx');
const ValidatorStore = require('../stores/ValidatorStore.jsx');

const ProductActions = require('../actions/ProductActions.jsx');
const QuestionActions = require('../actions/QuestionActions.jsx');
const PartActions = require('../actions/PartActions.jsx');
const AnswerActions = require('../actions/AnswerActions.jsx');
const ValidatorActions = require('../actions/ValidatorActions.jsx');
const PaymentPlanActions = require('../actions/PaymentPlanActions.jsx');
const SKUActions = require('../actions/SKUActions.jsx');

const Config = require('../configs/Config.js');
const Loader = require('../loaders');

const UCStore = Reflux.createStore({
  listenables: [UCActions],

  data: { loaded: false },
  loadStatus: {
    product: false,
    question: false,
    part: false,
    validator: false
  },

  init() {
    this.listenTo(ProductStore, this.registerStoreReady.bind(null, 'product'));
    this.listenTo(QuestionStore, this.registerStoreReady.bind(null, 'question'));
    this.listenTo(PartStore, this.registerStoreReady.bind(null, 'part'));
    this.listenTo(AnswerStore, this.registerStoreReady.bind(null, 'answer'));
    this.listenTo(ValidatorStore, this.registerStoreReady.bind(null, 'validator'));
  },

  registerStoreReady(storeType) {
    // No need to re-render if all stores are already loaded/registered
    if (this.data.loaded) {
      return;
    }

    this.loadStatus[storeType] = true;

    if (this.data.answers == undefined || this.data.answers == null) {
      this.data.answers = [];
    }

    if (Loader.defaultValues != null && _.isString(Loader.defaultValues)) {
      var pairs = Loader.defaultValues.split(';');
      _.each(pairs, (pair) => {
        var qa = pair.split('=');
        if (qa.length == 2) {
          if (this.data.answers.findIndex(a => a.question_id == qa[0]) == -1) {
            this.data.answers.push({
              question_id: qa[0],
              part_id: qa[1]
            });
          }
        }
      })
    }

    if (this.loadStatus.answer !== true && this.loadStatus.product === true && this.loadStatus.question === true && this.loadStatus.part == true && this.loadStatus.validator == true) {
      // @TODO: ideally we should account for default answers here as well as configured answers...
      AnswerActions.load(this.data.answers, this.dialogCB);
    }

    if (this.loadStatus.answer === true) {
      this.data.loaded = true;
      this.trigger(this.data);
    }
  },

  getInitialState() {
    return this.data;
  },

  onLoadProduct(id, schoolCode, channel, authKey, dialogCB, ln) {
    this.dialogCB = dialogCB;
    if (_.get(Config, 'schoolCodeRequired')) {
      this.loadUrl(`${Config.api.loadProduct + schoolCode}/${id}?ln=${ln}`, authKey);
    } else if (_.get(Config, 'channelRequired')) {
      this.loadUrl(`${Config.api.loadProduct + channel}/${id}?ln=${ln}`, authKey);
    } else {
      this.loadUrl(Config.api.loadProduct + id + '?ln=' + ln, authKey);
    }
  },

  onLoadConfig(id, productId, schoolCode, channel, authKey, dialogCB, ln) {
    this.dialogCB = dialogCB;

    if (_.get(Config, 'schoolCodeRequired')) {
      this.loadUrl(`${Config.api.loadConfig + id}/${schoolCode}/${productId}?ln=${ln}`, authKey);
    } else if (_.get(Config, 'channelRequired')) {
      this.loadUrl(`${Config.api.loadConfig + id}/${channel}/${productId}?ln=${ln}`, authKey);
    } else {
      this.loadUrl(`${Config.api.loadConfig + id}/${productId}?ln=${ln}`, authKey);
    }
  },

  onSetPaymentPlanFlag(flag) {
    return PaymentPlanActions.setAvailability(flag);
  },
  onSetPaymentPlanFlagActive(active) {
    return PaymentPlanActions.setActive(active, true);
  },

  loadUrl(url, authKey) {
    request
      .get(url)
      .set('Authorization', 'Bearer ' + authKey)
      .end((err, res) => {
        if(typeof res.body === 'object') {
          if (!res.body) {
            this.dialogCB('Error loading product data. Please check URL and try again.');
          } else {
            this.data = res.body;
            ProductActions.load(this.data.product);
            SKUActions.load(this.data.skus);
            QuestionActions.load(this.data.questions);
            PartActions.load(this.data.parts);
            ValidatorActions.load(this.data.questions);
          }
        } else {
          throw new Error('Error retrieving product data.');
        }
      });
  },

  getCategories() {
    return this.data.categories;
  }
});

module.exports = UCStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/UCStore.jsx